import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'NEW_CONVSERATION';

export const {
    action: send,
    success: sendSuccess,
    failed: sendFailed,
} = createAction(`${domain}/SEND_MESSAGE`, (body, participants, imageIds, fileIds) => ({
    body,
    participants,
    imageIds,
    fileIds,
}));
